import { FC } from 'react'
import {
  StyleCard,
  StyleLeftWrapper,
  StyleRightWrapper,
  StyleRowWrapper,
  StyleTag,
} from './style'
import Image from '@components/image'
import Row from '@components/row'
import Typography from '@components/typography'
import Svg from '@components/svg'
import Button from '@components/button'
import Skeleton from '@components/skeleton'
const InstituteDoctorCardLoader = () => {
  return (
    <StyleCard>
      <StyleRowWrapper>
        <StyleLeftWrapper>
          <Skeleton width={60} height={60} radius={30} />
        </StyleLeftWrapper>
        <StyleRightWrapper>
          <Row justifyContent="space-between" alignItems="center">
            <Row alignItems="center" colGap={5}>
              <Skeleton width={60} height={10} radius={4} />
            </Row>
            <Row alignItems="center" colGap={5}>
              <Skeleton width={20} height={20} radius={10} />
              <Skeleton width={10} height={10} radius={4} />
            </Row>
          </Row>
          <Row colGap={10}>
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
          </Row>
          <Row justifyContent="flex-end" colGap={5} alignItems="center">
            <Skeleton width={50} height={10} radius={4} />
          </Row>
          <Row colGap={10} justifyContent="space-between">
            <Skeleton width={'49%'} height={35} radius={8} />
            <Skeleton width={'49%'} height={35} radius={8} />
          </Row>
        </StyleRightWrapper>
      </StyleRowWrapper>
    </StyleCard>
  )
}

export default InstituteDoctorCardLoader
